import type { PhoneCall } from "../../lib/api";

/**
 * Talk time as m:ss, or a dash for a call nobody spoke on.
 *
 * Not "0:00" for an unanswered call: a zero reads as a call that connected
 * and ended at once, which is a different event -- a dropped line -- from one
 * that was never picked up.
 */
export function callDuration(call: Pick<PhoneCall, "durationSeconds" | "answered">): string {
  if (!call.answered && call.durationSeconds === 0) return "—";
  const seconds = Math.max(0, call.durationSeconds);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, "0");
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, "0")}:${rest}`
    : `${minutes}:${rest}`;
}

/** Which way, in words, with a missed call said to be one. */
export function directionLabel(call: Pick<PhoneCall, "direction" | "answered" | "missed">): string {
  if (call.missed) return "Missed";
  switch (call.direction) {
    case "inbound":
      return "Inbound";
    case "outbound":
      return call.answered ? "Outbound" : "Outbound, no answer";
    case "internal":
      return "Internal";
    default:
      return "Call";
  }
}
